var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rv-box-edit"},[_c('div',{staticClass:"rv-box-wrapper"},[_c('div',{staticClass:"rv-box"},[_c('box-image-big'),_c('div',{staticClass:"rv-puzzle-wrapper"},[_c('div',{class:['rv-puzzle-inner', _vm.isLandscapeFormat ? '' : 'portrait', _vm.isSquare ? 'square' : '']},[_c('div',{staticClass:"rv-puzzle",style:({
            transform: 'matrix3d(' + _vm.matrix3d + ')'
          })},[(_vm.showEditorWrapper)?_c('div',{class:['rv-collage-wrapper', 'notClickable'],style:({
              width: _vm.imageEditorWidth + 'px',
              height: _vm.imageEditorHeight + 'px',
              backgroundColor: '#ffffff',
              top: _vm.transformedOffsetY + 'px',
              left: _vm.transformedOffsetX + 'px'
            }),attrs:{"id":"editorWrapper"}},[_c('painting-by-numbers-editor-passive',{attrs:{"usageName":'paintingimage',"step":2}})],1):_vm._e()])])]),_c('box-image-overlay-big'),_c('div',{staticClass:"rv-box-title"},[_c('span',{staticClass:"rv-text-inner",style:({
          color: _vm.titleColor,
          top: _vm.titleOffsetY + 'px',
          left: _vm.titleOffsetX + 'px',
          fontSize: _vm.titleFontSize,
          transform: 'matrix3d(' + _vm.titleMatrix3d + ')'
        })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }